export const TEXT_ON_LIGHT = '#19304D';
export const TEXT_ON_DARK = '#FFFFFF';

export function normalizeHex(value: string): string | null {
  const match = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec(value);
  if (!match) return null;
  const digits = match[1].toUpperCase();
  if (digits.length === 3) {
    return `#${digits
      .split('')
      .map((digit) => digit + digit)
      .join('')}`;
  }
  return `#${digits}`;
}

export function isValidHex(value: string): boolean {
  return normalizeHex(value) !== null;
}

function relativeLuminance(hex: string): number {
  const normalized = normalizeHex(hex);
  if (!normalized) {
    throw new Error(`Invalid hex color: ${hex}`);
  }
  const [r, g, b] = [1, 3, 5].map((start) => {
    const channel = parseInt(normalized.slice(start, start + 2), 16) / 255;
    return channel <= 0.03928
      ? channel / 12.92
      : Math.pow((channel + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrastRatio(a: string, b: string): number {
  const la = relativeLuminance(a);
  const lb = relativeLuminance(b);
  const lighter = Math.max(la, lb);
  const darker = Math.min(la, lb);
  return (lighter + 0.05) / (darker + 0.05);
}

export function pickTextColor(
  background: string
): typeof TEXT_ON_LIGHT | typeof TEXT_ON_DARK {
  return contrastRatio(background, TEXT_ON_LIGHT) >
    contrastRatio(background, TEXT_ON_DARK)
    ? TEXT_ON_LIGHT
    : TEXT_ON_DARK;
}

export function formatContrastRatio(
  ratio: number,
  locale: 'pt' | 'en'
): string {
  const formatted = ratio.toFixed(1);
  return `${locale === 'pt' ? formatted.replace('.', ',') : formatted}:1`;
}

export function meetsAA(ratio: number): boolean {
  return ratio >= 4.5;
}
